module.exports = __webpack_public_path__ + "static/fonts/Mont-Bold.5660663.woff";